import { BaseFormPostInputModel } from "../../models/http/InputModel/BaseFormPostInputModel"
import { makeApiUrlPath } from "../makeApiUrlPath"
import { http } from "./http"
import { getTokenHeader } from "./lib/get-token-header"

export const httpFormPost = async <T>(
  endpointPath: string,
  model: BaseFormPostInputModel,
): Promise<T> => {
  const url = makeApiUrlPath(endpointPath, model)
  const tokenHeader = await getTokenHeader()
  const formData = new FormData()
  formData.append("file", model.file)

  return http
    .post<T>(url, formData, {
      headers: {
        "content-type": "multipart/form-data",
        ...tokenHeader,
        ...model.headers,
      },
    })
    .then((res) => res.data)
}
